import { ArrowIcon } from '@/assets/icons';
import Typography from '@/components/common/Typography';
import { useRouter } from 'next/router';
import { styled } from 'styled-components';

type SectionTitleProps = {
  title: string;
  slogan: string;
  link?: string;
};

export default function SectionTitle({ title, slogan, link }: SectionTitleProps) {
  const router = useRouter();

  const handleClick = () => {
    if (!link) return;
    router.push(link);
  };

  return (
    <Title isLink={Boolean(link)} onClick={handleClick}>
      <TitleWrapper>
        <CustomTypography>{title}</CustomTypography>
        {link && <ArrowIcon width={16} />}
      </TitleWrapper>
      <Typography variant="b2" color="gray800">
        {slogan}
      </Typography>
    </Title>
  );
}

const Title = styled.div<{ isLink?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
  cursor: ${({ isLink }) => isLink && 'pointer'};
`;

const CustomTypography = styled.h1`
  font-size: 23.5px;
  font-weight: bold;
  line-height: 28px;
  letter-spacing: -0.02em;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
